import { useSearchParams } from 'react-router-dom';
import { useLocalStorage, useMount } from 'react-use';
import { type QBPreferences } from 'types';
import { QB_PREFERENCES_STORAGE_KEY } from '../constants';

export const DEFAULT_COUNTRY = 'SE';

export const useLoginCountry = (): {
  loginCountry: string;
  changeLoginCountry: (country: string) => void;
} => {
  const [params] = useSearchParams();
  const countryCodeParam = params.get('countryCode');
  const defaultCountry = countryCodeParam ?? DEFAULT_COUNTRY;

  const [preferences, setPreferences] = useLocalStorage<QBPreferences>(
    QB_PREFERENCES_STORAGE_KEY,
    {
      loginCountry: defaultCountry,
    }
  );

  useMount(() => {
    if (
      preferences &&
      (!preferences.loginCountry ||
        (countryCodeParam && preferences.loginCountry !== countryCodeParam))
    ) {
      setPreferences({
        ...preferences,
        loginCountry: defaultCountry,
      });
    }
  });

  const changeLoginCountry = (country: string) => {
    setPreferences((p) => ({ ...p, loginCountry: country }));
  };

  return {
    loginCountry: preferences?.loginCountry || defaultCountry,
    changeLoginCountry,
  };
};
